<template>
    <div>
        <template v-if="notificationsNew.length">
            <h3>Новые уведомления ({{notificationsNew.length}})</h3>
            <transition-group name="list-complete" tag="div">
                <div class="list-complete-item" v-for="notification in notificationsNew" :key="'nn'+notification._id">
                    <NotificationCard :inNotificationsPage="true" :notification="notification"/>
                </div>
            </transition-group>
        </template>
        <h3>Все уведомления ({{notifications.length}})</h3>
        <button 
            style="margin:5px 5px 5px 0;"
            class="btn red darken-1" 
            :class="{disabled: !notifications.length}" 
            @click="deleteAllNotifications()"
        >
            <i class="material-icons left">delete</i>
            Удалить все
        </button>
        <NotificationsAutoDeleteSettings/>
        <transition-group name="list-complete" tag="div">
            <div class="list-complete-item" v-for="notification in notifications" :key="notification._id">
                <NotificationCard :inNotificationsPage="true" :notification="notification"/>
            </div>
        </transition-group>
    </div>
</template>

<style scoped>

.list-complete-item {
    transition: all 1s;
    display: inline-flex;
    width: 320px;
    margin:0 20px 10px 0;
}

.list-complete-enter, .list-complete-leave-to
    /* .list-complete-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
}

.list-complete-leave-active {
    position: absolute;
}

.item-container {
    display: flex;
    flex-wrap:wrap;
}

.item { 
    transition: all 1s;
    max-width: 320px;
    margin:0 20px 10px 0;
}

@media (max-width: 600px) {

    .list-complete-item {
        width:100%;
    }

}

</style>

<script>
import { mapActions, mapState } from 'vuex'
import NotificationCard from '@/components/notifications/NotificationCard.vue'
import NotificationsAutoDeleteSettings from '@/components/notifications/NotificationsAutoDeleteSettings.vue'

export default {
    computed:{
        ...mapState({
            userMe: state => state.user.userData,
            notificationsNew: state => state.notifications.notificationsNew,
            notifications: state => state.notifications.notifications.filter(note => note.seen),
        }),
    },
    components:{
        NotificationCard, NotificationsAutoDeleteSettings
    },
    methods:{
        ...mapActions([
            'getNotificationsNew', 
            'getNotifications', 
            'deleteAllNotifications'
        ]),
    },
    async created(){
        this.getNotificationsNew()
        this.getNotifications()
    },
}
</script>